import Table from 'react-bootstrap/Table';
import groupSubtopicsByIndex from './utils'

function TableTopicSubtopics({ data } ) {

  const groupedData = groupSubtopicsByIndex(data);
  
  return (
    <>
        <h2 style={{textAlign: 'center' }}>Результат поиска Интересов:</h2>
        <Table striped bordered hover>
            <thead>
                <tr>
                    {/* <th>#</th> */}
                    <th>Интерес</th>
                    <th>Индекс</th>
                    <th>Суб-интересы</th>
                    <th>Семантические токены</th>
                    <th>Интегральный вес суб-интереса</th>
                    {/* <th>Субинтерес</th>
                    <th>Семантические токены</th> */}
                </tr>
            </thead>
            <tbody>
                {groupedData.map((topic, tIndex) =>
                    topic.groupedSubtopics.map((group, gIndex) => {

                        const weightSum = group.semanticWords.reduce((sum, w) => sum + (w.weight || 0), 0);

                        const uniqueSemanticWords = Array.from(new Set(group.semanticWords.map(w => `${w.name} (${w.weight})`))).join(', ');
                        
                        return (
                            <tr key={`${tIndex}-${gIndex}`}>
                                <td>{topic.topic}</td>
                                <td>{group.index}</td>
                                <td>{group.names.join(' | ')}</td>
                                <td>
                                    {uniqueSemanticWords || '-'}
                                </td>
                                <td>{ weightSum }</td>
                            </tr>
                        );
                    })
                )}
            </tbody>
        </Table>
    </>
  );
}


export default TableTopicSubtopics;
